<template>
    <!-- card-hover-shadow  -->
    <v-container>
        <v-row>
            <v-col cols="12">
                <div class="brd-main">
                    <div class="d-flex pa-4">
                        <div class="w-50">
                            <div class="text-white fs-16">
                                กระเป๋าเงิน
                            </div>
                            <div class="text-white d-flex brd-in-main py-2 px-4 mt-2 position-relative">
                                <div class="">
                                    THB
                                </div>
                                <div class="fs-20 font-weight-bold ms-2">
                                    {{ getBalance }}
                                </div>
                                <div class="position-absolute reload-position cursor-pointer" @click="GetBalance()">
                                    <v-icon color="white">mdi-reload</v-icon>
                                </div>
                            </div>
                        </div>
                        <div class="w-50 d-flex justify-space-around ">
                            <v-btn rounded color="success" class="h-100  btn-dep-main" :class="paymeny['dep']['is_active'] ? 'bg-gold' : 'bg-silver'" @click="setActiveMenuPayment('dep')">
                                <div>
                                    <div class="d-flex justify-center">
                                        <img color="white" :src="icon_dep" width="40">
                                    </div>
                                    <div class="text-black mt-1">
                                        ฝากเงิน
                                    </div>
                                </div>
                            </v-btn>
                            <v-btn rounded color="success" class="h-100  btn-dep-main" :class="paymeny['with']['is_active'] ? 'bg-gold' : 'bg-silver'" @click="setActiveMenuPayment('with')">
                                <div>
                                    <div class="d-flex justify-center">
                                        <img color="white" :src="icon_withdraw" width="40">
                                    </div>
                                    <div class="text-black mt-1">
                                        ถอนเงิน
                                    </div>
                                </div>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <div :hidden="paymeny['dep']['is_active'] == false">
            <v-row v-if="getDepositDetail == null">
                <v-col cols="12">
                    <div>
                        <h5 class="text-white">เลือกบัญชีธนาคาร</h5>
                    </div>
                    <div class="mt-2">
                        <v-select class="custom-select" item-text="ACCNAME" item-value="ACCNO" v-model="getBankData.DepositSelectedBank"  :items="getBankData.Bank" hide-details
                            return-object label="เลือกบัญชีธนาคาร" solo>
                            <template v-slot:item="{ item, index }">
                                <div class="d-flex align-center py-2">
                                    <v-avatar left>
                                        <img :src="getImageBank(item)" alt="image" />
                                    </v-avatar>
                                    <div class="ml-2">
                                        <div class="font-weight-bold">{{ item.ACCNAME }}</div>
                                        <div class="fs-12">{{ item.ACCNO }}</div>
                                    </div>
                                </div>
                            </template>
    
                            <template v-slot:selection="{ item, index }">
                                <div class="123">
                                    <v-list-item>
                                        <v-list-item-avatar>
                                            <img :src="getImageBank(item)" alt="image" />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold text-white">{{ item.ACCNAME }}</v-list-item-title>
                                            <v-list-item-title class="fs-12 text-white">{{ item.ACCNO }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="mt-5">
                        <!-- <div>
                            <h5 class="text-white">โปรโมชั่น</h5>
                        </div> -->
                        <div class="mt-2">
                            <v-select class="custom-select" v-model="getPromotionSelected" :items="getPromotionList" item-text="PROMOTION_NAME" item-value="PROMOTION_ID" return-object label="เลือก โปรโมชั่น" solo hide-details>
                                <template v-slot:item="{ item, index, selected }">
                                    <div class="d-flex align-center mt-2" :class="{ 'selected-item': selected }">
                                        <div class="ml-2">
                                            <div class="font-weight-bold text-white">{{ item.PROMOTION_NAME }} {{ selected ? 't' : 'f' }}
                                            </div>
                                            <div class="fs-12 text-white">{{ item.PROMOTION_DES }}</div>
                                        </div>
                                    </div>
                                </template>
    
                                <template v-slot:selection="{ item, index }">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold text-white">{{ item.PROMOTION_NAME}}</v-list-item-title>
                                            <v-list-item-title class="fs-12 text-white">{{ item.PROMOTION_DES }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="mt-5">
                        <div>
                            <h5 class="text-white">จำนวนเงิน</h5>
                        </div>
                        <div class="mt-2">
                            <v-text-field class="custom-input text-white" type="number" v-model="amount_dep" label="จำนวนเงิน" hide-details solo></v-text-field>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="getDepositDetail == null">
                <v-col cols="12">
                    <v-btn  rounded  class="w-100 bg-gold" @click="checkDataDep()">
                        ถัดไป
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="getDepositDetail != null"> <!-- ทำรายการฝากแล้ว รอ โอนเงิน -->
                <v-col cols="12" class="text-white">
                    <!-- {{ getDepositDetail }} -->
                    <div class="" v-if="getDepositTimeCount != 0"> <!-- ทำรายการฝากแล้ว ยังไม่หมดเวลา -->
                        <div class="text-center">
                            <h5 class="text-white">โอนเข้าบัญชีด้านล่าง</h5>
                        </div>
                        <div class="mt-2 position-relative">
                            <div class="d-flex align-center tranfer-to-acc w-100">
                                <v-avatar left>
                                    <img :src="getImageBank(getDepositDetail.BANK)" alt="image" />
                                </v-avatar>
                                <div class="ml-2">
                                    <div >
                                        <div class="font-weight-bold">{{ getDepositDetail.BANK.BANK }}</div>
                                        <div class="font-weight-bold">{{ getDepositDetail.BANK.ACCNO }}</div>
                                        <div class="fs-12">{{ getDepositDetail.BANK.NAME }}</div>
                                       
                                    </div>
                                </div>
                            </div>
                            <div class="position-absolute copy-btn-pos">
                                <v-btn class="bg-gold" rounded color="success">
                                    Copy
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5" v-if="getDepositTimeCount != 0">
                        <div>
                            <h5 class="text-white">จำนวนเงินที่ต้องโอน</h5>
                        </div>
                        <div class="mt-2">
                            <v-text-field class="custom-input" type="number" :value="getDepositDetail.dep_detail.Amount" label="จำนวนเงิน" hide-details solo readonly></v-text-field>
                        </div>
                        
                       
                        <div class="text-center mt-5">
                            <div class="text-white">กรุณาทำรายการภายใน <span class="font-weight-bold">&ensp;{{ getDepositTimeCount }}&ensp;</span>วินาที</div>
                        </div>
                    </div>
                    <div class="" v-if="getDepositTimeCount == 0"> <!-- หมดเวลาแล้ว -->
                        <div v-if="getDepositSlipDetail == null">
                            <div class="text-center ">
                                <h2 class="text-red">ขออภัยในความไม่สะดวก</h2>
                            </div>
                            <div class="text-center mt-4">
                                <h4 class="text-white">หมดเวลาทำรายการ กรุณาติดต่อ Call center</h4>
                            </div>
                            <div class="text-center mt-4">
                                <h4 class="text-white">— หรือ —</h4>
                            </div>
                            <div class="text-center mt-4">
                                <input type="file" id="file" accept="image/png, image/jpeg, image/bmp, image/jpg, image/gif" style="display:none;" name="file" @change="UploadSlipDeposit($event);" />
                               
                                <h4 class="text-white" @click="PressFileUploadSlip()">กดที่นี่เพื่อแนบสลิปรายการโอน</h4>
                            </div>
                        </div>
                        <div v-if="getDepositSlipDetail != null" >
                            <v-btn  rounded color="green" class="w-100" @click="SendSlipDepositCheck()">
                                ยืนยันแนบสลิปทำรายการ
                            </v-btn>
                            <img class="mt-5" :src="'https://uploads.facup.bet/' + getDepositSlipDetail.IMGSource" alt="" width="100%">
                        </div>
                    </div>
                    <div class="mt-5">
                        <v-btn  rounded color="red" class="w-100" @click="DepositCancel()">
                            ยกเลิกการทำรายการ
                        </v-btn>
                    </div>
                     <!-- {{ getDepositDetail }} -->
                </v-col>
            </v-row>
        </div>
        
        <div :hidden="paymeny['with']['is_active'] == false">
            <v-row >
                <v-col cols="12">
                    <div>
                        <h5 class="text-white">บัญชี</h5>
                    </div>
                    <div class="mt-2">
                        <v-select class="custom-select" item-text="ACCNAME" item-value="ACCNO" v-model="getBankData.WithdrawSelectedBank"  :items="getBankData.Bank" hide-details
                            return-object label="เลือกบัญชีธนาคาร" solo>
                            <template v-slot:item="{ item, index }">
                                <div class="d-flex align-center py-2">
                                    <v-avatar left>
                                        <img :src="getImageBank(item)" alt="image" />
                                    </v-avatar>
                                    <div class="ml-2">
                                        <div class="font-weight-bold text-white">{{ item.ACCNAME }}</div>
                                        <div class="fs-12 text-white">{{ item.ACCNO }}</div>
                                    </div>
                                </div>
                            </template>
    
                            <template v-slot:selection="{ item, index }">
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <img :src="getImageBank(item)" alt="image" />
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold text-white">{{ item.ACCNAME }}</v-list-item-title>
                                        <v-list-item-title class="fs-12 text-white">{{ item.ACCNO }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>
                    <div class="mt-5">
                        <div>
                            <h5 class="text-white">จำนวนเงิน</h5>
                        </div>
                        <div class="mt-2">
                            <v-text-field type="number" class="custom-input" v-model="amount_with" label="จำนวนเงิน" hide-details solo></v-text-field>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-btn  rounded class="w-100 bg-gold" @click="checkDataWith()">
                        ยืนยัน
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <!-- <v-row>
            <v-col cols="12"  class="pt-0">
                <template>
                    <v-card class="bg-black">

                        <v-tabs v-model="tab" background-color="transparent">
                            <v-tab v-for="item in items" :key="item">
                                <span class="text-white">{{ item }}</span>
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <v-card class="bg-black" flat>
                                    <v-simple-table dark fixed-header :height="heightContent">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        วัน/เวลา
                                                    </th>
                                                    <th class="text-left">
                                                        รายการ
                                                    </th>
                                                    <th class="text-left">
                                                        จำนวนเงิน
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in statmentList" :key="item.name">
                                                    <td>{{ item.CREATE_DATE }}</td>
                                                    <td>{{ item.DESC }}</td>
                                                    <td>{{ item.TYPE == 'DEP' ? '+' : '-' }} {{ item.AMT }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card class="bg-black" flat>
                                    <v-simple-table dark fixed-header :height="heightContent">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        วัน/เวลา
                                                    </th>
                                                    <th class="text-left">
                                                        รายการ
                                                    </th>
                                                    <th class="text-left">
                                                        ผล
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in betList" :key="item.name">
                                                    <td>{{ item.DateTime }}</td>
                                                    <td>
                                                        <span v-if="item.BetType == 'BetPlace'">วางเดิมพัน</span>
                                                        <span v-if="item.BetType == 'BetResult'">แพ้/ชนะ</span>
                                                        <span v-if="item.BetType == 'BetReturn'">คืนเงินเดิมพัน</span>
                                                        <span v-if="item.BetType == 'BetTransfer'">โอนย้ายเงินเดิมพัน</span> : <font color="#fff0cd"><small>{{ item.GameName }}</small></font><br>
                                                        <small>BetID : {{ item.RefId }} </small>
                                                    </td>
                                                    <td>
                                                        <span class="text-success" v-if="item.WinLose >= 0 && item.WinLose != 0">+ {{ item.WinLose }}</span>
                                                        <span class="text-danger" v-if="item.WinLose < 0 && item.WinLose != 0">{{ item.WinLose }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </template>
            </v-col>
        </v-row> -->
    </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { createToastInterface } from 'vue-toastification';
export default {
    props: {
        cardHoverShadow: {
            type: Boolean,
            default: false
        },
        contentImg: String,
        contentText: String,
        amount: {
            type: Number,
            default: 200
        },
        contentRating: {
            type: Number,
            default: 4.5
        }
    },
    computed: {
        ...mapGetters([ 'getProducts', 'getBankData', 'getPromotionList', 'getPromotionSelected', 'getDepositTimeCount', 'getDepositDetail', 'getDepositSlipDetail', 'getBalance', 'getIsLogin' ]),
        getPromotionSelected: {
            get() {
                return this.$store.getters.getPromotionSelected;
            },
            set(value) {
                this.$store.commit('SET_PROMOTION_SELECTED', value);
            }
        },
        getBankData: {
            get() {
                return this.$store.getters.getBankData;
            },
            set(value) {
                this.$store.commit('SET_BANK_DATA', value);
            }
        }
    },
    data() {
        return {
            dialog: false,
            counter: 0,
            tab: null,
            items: [
                'ประวัติ ฝาก-ถอน', 'ประวัติการเล่น'
            ]
            ,statmentList: []
            ,betList: []
            ,heightContent: 0
            ,electedItem: null
            ,amount_dep: null
            ,amount_with: null
            ,icon_dep: require('@/assets/images/payment/dep.png')
            ,icon_withdraw: require('@/assets/images/payment/wit.png')
            ,paymeny: {
                dep: {
                    is_active: true
                },
                with: {
                    is_active: false
                }
            }
        }
    },
    async mounted(){
        this.GetBankMember();
        this.PromotionList();
        this.GetBalance();
        // var resStData = await this.GetStatement();
        // if (resStData != false && resStData.Status == 'OK') this.statmentList = resStData.Data;
        // var resBetData = await this.TransactionBet();
        // if (resBetData != false && resBetData.Status == 'OK') this.betList = resBetData.Data;
        // set height calc(100vh - 206px)
        this.heightContent = window.innerHeight - 270 + 'px';
        // receive data from params promotionId
        // console.log('Deposit.vue -> mounted -> this.$route.params', this.$route.params)
        if (this.$route.params.hasOwnProperty('promotionId')) {
            this.getPromotionSelected = this.getPromotionList.find(item => item.PROMOTION_ID == this.$route.params.promotionId)
        }
    },
    methods: {
        ...mapActions(["Withdraw", "GetStatement", "TransactionBet","GetBankMember", "PromotionList", "Deposit", "DepositCancel", "UploadSlip", "SendSlipDeposit", "GetBalance", "setModalLogin"]),
        // addCart() {
        //   this.counter++

        // },
        addCartx(product) {
            // this.addCart(item);
            // if(item.qty == 1)
            //   this.cartCount++
            // console.log(product);

        },
        goTo(route) {
            this.$router.push({ name: route });
        },
        setActiveMenuPayment(type) {
            if (type == 'dep') {
                this.paymeny.dep.is_active = true
                this.paymeny.with.is_active = false
            } else {
                this.paymeny.dep.is_active = false
                this.paymeny.with.is_active = true
            }
        },
        getImageBank(item) {
            return require(`@/assets/images/_banks/${item.BANK}.png`);
        },
        async checkDataDep() {
            if (!this.getIsLogin) {
                this.setModalLogin(true)
                return
            }
            // validate
            if (this.amount_dep == null || this.amount_dep == 0) {
                createToastInterface().error('กรุณากรอกจำนวนเงิน');
                return;
            }
            let objReqDep = {
                Amount: this.amount_dep,
                BankId: this.getBankData.DepositSelectedBank.ACCNO,
                Promotion: this.getPromotionSelected == null ? 'none' : this.getPromotionSelected.PROMOTION_ID
            }
            , resDep = await this.Deposit(objReqDep)
            // console.log('Deposit.vue -> checkDataDep -> objReqDep', JSON.stringify(objReqDep, null, 2), JSON.stringify(resDep, null, 2))
        },
        PressFileUploadSlip() {
            document.getElementById('file').click();
        },
        async UploadSlipDeposit(event) {
            var formdata = new FormData();
            formdata.append("file", event.target.files[0]);
            formdata.append("mode", '_slip');
            let resUploadSlip = await this.UploadSlip(formdata)
            if (resUploadSlip.Status == "OK") {
                var image = 'https://uploads.facup.bet/' + resUploadSlip.Data.IMGSource;
            }
            // console.log('Deposit.vue -> UploadSlipDeposit -> event', resUploadSlip)
        },
        async SendSlipDepositCheck() {
            let res = await this.SendSlipDeposit()
            if (res !== false) {
                this.amount_dep = null
            }
        },
        async checkDataWith() {
            // validate
            if (this.amount_with == null || this.amount_with == 0) {
                createToastInterface().error('กรุณากรอกจำนวนเงิน');
                return;
            }
            let objReqDep = {
                Amount: this.amount_with,
                BankId: this.getBankData.WithdrawSelectedBank.ACCNO
            }
            , resDep = await this.Withdraw(objReqDep)
            // console.log('Deposit.vue -> checkDataDep -> objReqDep', JSON.stringify(objReqDep, null, 2), JSON.stringify(resDep, null, 2))
        }

    }
}
</script>
<style lang="scss" scoped>
.br-t-8 {
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

.card-hover {
    &:hover {
        .card-hover-icon {
            display: block;
        }
    }

    .card-hover-icon {
        display: none;
    }
}
.tb-fix-height {
    height: calc(100vh - 270px) !important;
}
.tranfer-to-acc {
    width: 100%;
    border: 1px solid #cc9038;
    padding: 10px;
    border-radius: 10px;
}
.copy-btn-pos {
    right: 9px;
    top: 23px;
}
.theme--light.v-label {
    color: #9e9e9e !important;
}
.label.v-label.theme--light {
    color: #cc9038 !important;
}
</style>